import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { from } from '@helpers/media';
import { h4, paragraphRegular } from '@helpers/typography';
import ContactCardStyles from '@stories/Widgets/ContactCard/ContactCard.styles';
import styled from 'styled-components';
const containerBreak = 480;
const Container = styled.article `
  background-color: ${brand.global.beige};
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${fluid(16, 22)};
  border-radius: 20px 20px 20px 0;
  padding: ${fluid(18, 26)} ${fluid(16, 26)};

  @container ${from(containerBreak)} {
    flex-direction: row;
    gap: ${fluid(64, 128)};
  }
`;
const Title = styled.p `
  ${h4};

  margin: 0;
`;
const Number = styled(ContactCardStyles.ContactNumber) `
  color: ${brand.green.dark};
  margin-bottom: 0;
`;
const Section = styled.div `
  ${paragraphRegular};
  ${fonts.proximaNova.semiBold};

  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  border-top: 1px solid ${brand.grey.light};
  margin: 0;
  padding: ${fluid(16, 22)} 0 0;

  @container ${from(containerBreak)} {
    flex-direction: row;
    border: 0;
    padding-top: 0;

    &:first-of-type {
      margin-left: auto;
    }
  }
`;
const Icon = styled.div `
  display: grid;
  place-content: center;
  width: ${fluid(32, 36)};
  aspect-ratio: 1;
  border-radius: 5000px;
  color: ${brand.global.white};
  background-color: ${brand.green.default};

  svg {
    display: block;
    width: 24px;
  }
`;
const OpeningHours = styled.table `
  margin-right: auto;

  tr td:first-of-type {
    padding-right: ${fluid(24, 50)};
  }

  tr:not(:last-of-type) td {
    padding-bottom: ${fluid(4, 6)};
  }
`;
const CtaWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${fluid(8, 10)};
  z-index: 2;
`;
const CardLink = styled.a `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-decoration: none;
  color: inherit;
`;
const BranchCardStyles = {
    CardLink,
    Container,
    CtaWrapper,
    Icon,
    Title,
    Number,
    Section,
    OpeningHours,
};
export default BranchCardStyles;
